import axios from "axios";
import { logout } from "@/apis/user-authentication";

export function axiosInit() {
  axios.interceptors.response.use(function (response) {
    return response;
  }, handleResponseError);
}

function handleResponseError(error) {
  if (error.response && error.response.status === 401) {
    // assume standard unauthorized access and redirect without an alert
    localStorage.setItem("user_access", "unauthorized");
    const successUrl = new URL(window.location.origin);
    logout(successUrl);
  }

  return Promise.reject(error);
}
